"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Keyboard = void 0;
class Keyboard {
    constructor() {
        this.keys = new Uint8Array(256);
        for (let i = 0; i < 256; ++i) {
            this.keys[0] = 0;
        }
    }
}
exports.Keyboard = Keyboard;
(function (Keyboard) {
    let KEYS;
    (function (KEYS) {
        KEYS[KEYS["A"] = 'A'.charCodeAt(0)] = "A";
        KEYS[KEYS["B"] = 'B'.charCodeAt(0)] = "B";
        KEYS[KEYS["C"] = 'C'.charCodeAt(0)] = "C";
        KEYS[KEYS["D"] = 'D'.charCodeAt(0)] = "D";
        KEYS[KEYS["E"] = 'E'.charCodeAt(0)] = "E";
        KEYS[KEYS["F"] = 'F'.charCodeAt(0)] = "F";
        KEYS[KEYS["G"] = 'G'.charCodeAt(0)] = "G";
        KEYS[KEYS["H"] = 'H'.charCodeAt(0)] = "H";
        KEYS[KEYS["I"] = 'I'.charCodeAt(0)] = "I";
        KEYS[KEYS["J"] = 'J'.charCodeAt(0)] = "J";
        KEYS[KEYS["K"] = 'K'.charCodeAt(0)] = "K";
        KEYS[KEYS["L"] = 'L'.charCodeAt(0)] = "L";
        KEYS[KEYS["M"] = 'M'.charCodeAt(0)] = "M";
        KEYS[KEYS["N"] = 'N'.charCodeAt(0)] = "N";
        KEYS[KEYS["O"] = 'O'.charCodeAt(0)] = "O";
        KEYS[KEYS["P"] = 'P'.charCodeAt(0)] = "P";
        KEYS[KEYS["Q"] = 'Q'.charCodeAt(0)] = "Q";
        KEYS[KEYS["R"] = 'R'.charCodeAt(0)] = "R";
        KEYS[KEYS["S"] = 'S'.charCodeAt(0)] = "S";
        KEYS[KEYS["T"] = 'T'.charCodeAt(0)] = "T";
        KEYS[KEYS["U"] = 'U'.charCodeAt(0)] = "U";
        KEYS[KEYS["V"] = 'V'.charCodeAt(0)] = "V";
        KEYS[KEYS["W"] = 'W'.charCodeAt(0)] = "W";
        KEYS[KEYS["X"] = 'X'.charCodeAt(0)] = "X";
        KEYS[KEYS["Y"] = 'Y'.charCodeAt(0)] = "Y";
        KEYS[KEYS["Z"] = 'Z'.charCodeAt(0)] = "Z";
        KEYS[KEYS["CTRL"] = 17] = "CTRL";
        KEYS[KEYS["SHIFT"] = 16] = "SHIFT";
        KEYS[KEYS["ALT"] = 18] = "ALT";
        KEYS[KEYS["SPACE"] = 32] = "SPACE";
    })(KEYS = Keyboard.KEYS || (Keyboard.KEYS = {}));
})(Keyboard || (exports.Keyboard = Keyboard = {}));
